var _g;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgSports(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 85,
    height: 14,
    viewBox: "0 0 85 14",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Symbols",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Switch-/-Large-/-3.-Sports",
    transform: "translate(-232 -6)",
    fill: "#FDFDFD"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-3",
    transform: "translate(0 2)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "4_PSSportLogo_Pos_RGB",
    transform: "translate(232)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "primary",
    d: "M0 8.511c0 2.392 1.653 3.578 4.336 3.714l2.158.117c1.245.058 2.14.427 2.14 1.283 0 1.03-.934 1.536-3.015 1.536-1.827 0-3.577-.233-5.172-.564v2.917c1.42.291 3.578.486 5.075.486 3.345 0 6.28-1.089 6.28-4.55 0-2.586-1.594-3.83-4.296-3.986L4.9 9.308c-1.225-.077-1.77-.447-1.75-1.264.02-.816.992-1.322 2.605-1.322 1.79 0 3.345.194 5.134.603V4.486C9.528 4.175 7.836 4 5.989 4 2.645 4 0 5.361 0 8.511zm21.51-4.316h-7.758v13.61h3.286v-4.53h3.889c3.442 0 5.23-1.925 5.23-4.705 0-2.723-1.672-4.375-4.647-4.375zm-1.108 6.357h-3.364V6.78h3.636c1.225 0 2.061.525 2.061 1.828 0 1.342-.797 1.944-2.333 1.944zM35.325 4c-4.16 0-7.524 2.353-7.524 7.039 0 4.608 3.363 6.961 7.524 6.961s7.525-2.353 7.525-6.961C42.85 6.353 39.486 4 35.325 4zm0 11.278c-2.255 0-4.025-1.44-4.025-4.24 0-2.877 1.77-4.296 4.025-4.296 2.256-.02 4.025 1.4 4.025 4.297 0 2.82-1.77 4.258-4.025 4.239zm18.985 2.527h3.987l-4.045-5.113c2.08-.428 3.306-2.1 3.306-4.298 0-2.372-1.458-4.2-4.628-4.2h-7.894v13.611h3.286v-4.88h2.333l3.655 4.88zM48.322 6.78h3.675c1.225 0 2.138.486 2.138 1.79 0 1.224-.894 1.73-2.236 1.73h-3.577V6.78zm23.165-2.585H59.14v2.838h4.55v10.772h3.286V7.033h4.511V4.195zm1.524 4.316c0 2.392 1.653 3.578 4.336 3.714l2.159.117c1.244.058 2.138.427 2.138 1.283 0 1.03-.933 1.536-3.013 1.536-1.828 0-3.578-.233-5.172-.564v2.917c1.419.291 3.577.486 5.074.486 3.345 0 6.28-1.089 6.28-4.55 0-2.586-1.593-3.83-4.296-3.986l-2.606-.156c-1.225-.077-1.77-.447-1.75-1.264.02-.816.992-1.322 2.606-1.322 1.789 0 3.344.194 5.133.603V4.486C82.54 4.175 80.847 4 79 4c-3.344 0-5.989 1.361-5.989 4.511z",
    id: "Fill-14"
  })))))));
}

SvgSports.displayName = 'Sports';
export default SvgSports;